import { useEffect, useState } from "react";
import { useAuthToken } from "./useAuthToken";
import {
  CallStatus,
  ParticipantStatus,
  useIncomingCallSubscription,
} from "../graphql";

const useIncomingCall = () => {
  const { accountId } = useAuthToken();
  const [calling, setCalling] = useState(false);
  const [ringing, setRinging] = useState(false);
  const [answering, setAnswering] = useState(false);

  const { loading, error, data } = useIncomingCallSubscription();

  const call = data?.incomingCall?.call;
  const callStatus = call?.status;
  const myAccount = call?.participants?.find((p) => p.account.id === accountId);

  useEffect(() => {
    if (myAccount) {
      if (myAccount.status === ParticipantStatus.Answered) {
        setAnswering(true);
      } else {
        setAnswering(false);
      }

      if (myAccount.status === ParticipantStatus.Ringing) {
        setRinging(true);
      } else {
        setRinging(false);
      }

      if (
        myAccount.status === ParticipantStatus.Answered ||
        myAccount.status === ParticipantStatus.Ringing
      ) {
        setCalling(true);
      } else {
        setCalling(false);
      }
    } else {
      setAnswering(false);
      setCalling(false);
      setRinging(false);
    }
  }, [callStatus, myAccount]);

  return { loading, error, call, data, calling, answering, ringing };
};

export { useIncomingCall };
